import AppLogoIcon from "./app-logo-icon"

export default function AppLogo() {
  return (
    <>
      <div className="flex items-center justify-center">
        <AppLogoIcon className="h-8 w-auto" />
      </div>
    </>
  )
}
